// extracted by mini-css-extract-plugin
export default {"tabs":"loe-table_tabs__bcDku"};